/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyOfficeTypeCreateDto } from '../../models/company-office-type-create-dto';
import { CompanyOfficeTypeItem } from '../../models/company-office-type-item';

export interface OfficeControllerCreateOfficeType$Params {
      body: CompanyOfficeTypeCreateDto
}

export function officeControllerCreateOfficeType(http: HttpClient, rootUrl: string, params: OfficeControllerCreateOfficeType$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyOfficeTypeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerCreateOfficeType.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyOfficeTypeItem;
      }>;
    })
  );
}

officeControllerCreateOfficeType.PATH = '/company/office/type';
